export default {
  uk: "Українська",
  en: "English",
  hu: "Magyar"
}
